const HTML_TAG_REGEX = /(<([^>]+)>)/gi;
const MIN_STRIPPED_TEXT_LENGTH = 2;
export const MAX_FIELD_CHAR_LIMIT = 10000;

export const isHtmlFieldEmpty = (html: string): boolean => {
  const stripped = html
    ?.replace(/&nbsp;/g, "")
    .replace(HTML_TAG_REGEX, "")
    .replace(/\s/g, "")
    .replace(/\n/g, "");
  return !stripped || stripped.length < MIN_STRIPPED_TEXT_LENGTH;
};

export const validateNewFlowFields = (
  whatWentWell: string,
  whatCouldBeDifferent: string,
  overallFeedback: string
): { valid: boolean; reason?: "missing" | "charLimit" } => {
  if (isHtmlFieldEmpty(whatWentWell) || isHtmlFieldEmpty(whatCouldBeDifferent) || isHtmlFieldEmpty(overallFeedback)) {
    return { valid: false, reason: "missing" };
  }
  if (whatWentWell.length > MAX_FIELD_CHAR_LIMIT || whatCouldBeDifferent.length > MAX_FIELD_CHAR_LIMIT || overallFeedback.length > MAX_FIELD_CHAR_LIMIT) {
    return { valid: false, reason: "charLimit" };
  }
  return { valid: true };
};
